import { ParameterType, Type } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';

export function createStreamingChunk() : ParameterType
{
    const usageType = ApiRef.getType("Usage");

    const desc = (<>
        <h3>Streaming Chunk</h3>
        <p>There are four types of chunks: info, delta, stop, and error. The type determines which other
           parameters are present in the chunk:</p>
        <ul>
            <li><strong>Info chunks</strong> - Status messages during model loading (e.g., "Loading model", "Loading tokenizer")</li>
            <li><strong>Delta chunks</strong> - Incremental text tokens as they are generated</li>
            <li><strong>Stop chunks</strong> - Final chunk indicating generation is complete, includes stop reason and usage statistics</li>
            <li><strong>Error chunks</strong> - Error messages when something goes wrong during processing</li>
        </ul>
        </>);

    return {
        id          : "StreamingChunk",
        name        : "StreamingChunk",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "type",
                "type"        : "string",
                "description" : <p>The type of chunk. Can be "info", "delta", "stop", or "error". The type determines which other parameters are present in the chunk.</p>,
                "optional"    : false
            },
            {
                "name"        : "message",
                "type"        : "string",
                "description" : <p>Present in info and error chunks. Contains status messages during model loading (info chunks) or error messages (error chunks).</p>,
                "optional"    : true
            },
            {
                "name"        : "delta",
                "type"        : "string",
                "description" : <p>Present in delta chunks. Contains incremental text tokens as they are generated.</p>,
                "optional"    : true
            },
            {
                "name"        : "stop_reason",
                "type"        : "string",
                "description" : <p>Present in stop chunks. Indicates why generation stopped (e.g., "end_turn", "max_tokens", etc.).</p>,
                "optional"    : true
            },
            {
                "name"        : "usage",
                "type"        : "Usage",
                "description" : <><p>Present in stop chunks. Contains usage statistics for the generation.</p>{ usageType.description }</>,
                "optional"    : true
            }
        ]
    };
}

export function createStreamingChunks() : ParameterType
{
    const childType = ApiRef.getType("StreamingChunk");

    const desc = (<>
        <h3>Streaming Response</h3>
        <p>When streaming is enabled (stream: true), the response is sent as a series of chunks. Each chunk represents a different part of the generation process:</p>
        <ul>
            <li><strong>Info chunks</strong> - Status messages during model loading (e.g., "Loading model", "Loading tokenizer")</li>
            <li><strong>Delta chunks</strong> - Incremental text tokens as they are generated</li>
            <li><strong>Stop chunks</strong> - Final chunk indicating generation is complete, includes stop reason and usage statistics</li>
        </ul>
        </>);

    return {
        id          : "StreamingChunk[]",
        name        : "StreamingChunks",
        description : desc,
        type        : Type.Array,
        childType   : childType
    };
}

